var passiveEvent = false;
try {
  var opts = Object.defineProperty({}, "passive", {
    get: function () {
      passiveEvent = passiveEvent ? { capture: true, passive: true } : true;
    },
  });
  window.addEventListener("test", null, opts);
} catch (e) {}

function generateUUID() {
  var d = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

function myDate() {
  let myDate = new Date();
  return encodeURI(myDate.toISOString().replace(/:/g, "#"));
}
function changeParam(param) {
  return JSON.stringify(param)
    .replace(/:/g, "=")
    .replace(/,/g, "&")
    .replace(/{/g, "")
    .replace(/}/g, ``)
    .replace(/"/g, "")
    .replace("[", "")
    .replace("]", "")
    .replace(/#/g, ":");
}
function sendMassage(type, data) {
  let xhr = new XMLHttpRequest();
  var userEventTypeName = type;
  var sendUserTypeName = data;
  let sendUserMassageSTR =
    "https://avalondataengine.yqslmall.com/concise/api/logpush/v1.0/ecommerce/drinkgenki/";
  xhr.open(
    "get",
    sendUserMassageSTR +
      userEventTypeName +
      "?" +
      changeParam(sendUserTypeName),
    true
  );
  xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhr.send();
}

var mouseToenter = new Array();
let firstX = 0,
  firstY = 0,
  endX = 0,
  endY = 0;
let timeStamp = function () {
  setTimeout(() => {
    timeNum++;
  }, 1000);
};
window.addEventListener("load", function (e) {
  let userData = {
    type: "load",
    uuid: generateUUID(),
    currentTime: myDate(),
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    s: encodeURI(document.cookie).replace(/=/g, "%3d"),
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    locationUrl: encodeURIComponent(window.location.href),
    fromUrl: encodeURIComponent(document.referrer),
    // usr_id:customer.id
  };
  sendMassage("load", userData);
});
var touchPhoneTAGlist = new Array();
document.body.addEventListener(
  "touchstart",
  function (e) {
    firstX = e.targetTouches[0].clientX;
    firstY = e.targetTouches[0].clientY;
    let touchPress = {
      uuid: generateUUID(),
      currentTime: myDate(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
      touchStartTag: e.srcElement.classList[0],
      touchStarTime: myDate(),
      beginX: firstX,
      beginY: firstY,
      cookies: encodeURIComponent(document.cookie),
      locationUrl: encodeURIComponent(window.location.href),
      fromUrl: encodeURIComponent(document.referrer),
    };
    touchPhoneTAGlist.push(touchPress);
  },
  passiveEvent
);
document.body.addEventListener(
  "touchend",
  function (e) {
    endX = e.changedTouches[0].clientX;
    endY = e.changedTouches[0].clientY;
    moveX = endX - firstX;
    moveY = endY - firstY;
    let touchLoosen = {
      type: "touchMove",
      touchID: encodeURI(e.srcElement.id)
        .replace(/=/g, "%3d")
        .replace(/:/g, "%3a"),
      touchEndTag: encodeURI(e.srcElement.classList)
        .replace(/=/g, "%3d")
        .replace(/:/g, "%3a"),
      eAlt: encodeURI(e.srcElement.art)
        .replace(/=/g, "%3d")
        .replace(/:/g, "%3a"),
      eSrc: encodeURI(e.srcElement.src)
        .replace(/=/g, "%3d")
        .replace(/:/g, "%3a"),
      touchEndTime: myDate(),
      endX: endX,
      endY: endY,
      touchDirection: null,
    };

    if (Math.abs(moveX) > 60 || Math.abs(moveY) > 60) {
      if (Math.abs(moveX) > Math.abs(moveY)) {
        var ele = moveX > 0 ? "right" : "left";
        touchLoosen.touchDirection = ele;
      } else {
        var ele = moveY > 0 ? "down" : "up";
        touchLoosen.touchDirection = ele;
      }
      touchPhoneTAGlist.push(touchLoosen);
      sendMassage("touch", touchPhoneTAGlist);
      touchPhoneTAGlist = new Array();
    } else {
      let touchClick = {
        type: "touchClick",
        uuid: generateUUID(),
        currentTime: myDate(),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookies: encodeURI(document.cookie).replace(/=/g, "%3d"),
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
        clickId: encodeURI(e.srcElement.id)
          .replace(/=/g, "%3d")
          .replace(/:/g, "%3a"),
        clickTag: encodeURI(e.srcElement.classList)
          .replace(/=/g, "%3d")
          .replace(/:/g, "%3a"),
        eAlt: encodeURI(e.srcElement.art)
          .replace(/=/g, "%3d")
          .replace(/:/g, "%3a"),
        eSrc: encodeURI(e.srcElement.src)
          .replace(/=/g, "%3d")
          .replace(/:/g, "%3a"),
        clientX: e.changedTouches[0].clientX,
        clientY: e.changedTouches[0].clientY,
        pageX: e.changedTouches[0].pageX,
        pageY: e.changedTouches[0].pageY,
        screenX: e.changedTouches[0].screenX,
        screenY: e.changedTouches[0].screenY,
        radiusX: e.changedTouches[0].radiusX,
        radiusY: e.changedTouches[0].radiusY,
        touchClickTime: myDate(),
        locationUrl: encodeURIComponent(window.location.href),
        fromUrl: encodeURIComponent(document.referrer),
      };
      sendMassage("touch", touchClick);
      touchPhoneTAGlist = new Array();
    }
  },
  passiveEvent
);
document.body.addEventListener("click", function (e) {
  let webClick = {
    uuid: generateUUID(),
    currentTime: myDate(),
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    cookies: encodeURI(document.cookie).replace(/=/g, "%3d"),
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    type: "Webclick",
    clickId: encodeURI(e.srcElement.id)
      .replace(/=/g, "%3d")
      .replace(/:/g, "%3a"),
    clickClass: encodeURI(e.srcElement.classList)
      .replace(/=/g, "%3d")
      .replace(/:/g, "%3a"),
    eAlt: encodeURI(e.srcElement.art).replace(/=/g, "%3d").replace(/:/g, "%3a"),
    eSrc: encodeURI(e.srcElement.src).replace(/=/g, "%3d").replace(/:/g, "%3a"),
    clientX: e.clientX,
    clientY: e.clientY,
    offsetX: e.offsetX,
    offsetY: e.offsetY,
    pageX: e.pageX,
    pageY: e.pageY,
    locationUrl: encodeURIComponent(window.location.href),
    fromUrl: encodeURIComponent(document.referrer),
  };
  sendMassage("click", webClick);
});
window.addEventListener("unload", function (e) {
  let unLoad = {
    type: "unLoad",
    uuid: generateUUID(),
    currentTime: myDate(),
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    cookies: encodeURI(document.cookie).replace(/=/, "%3d"),
    locationUrl: encodeURIComponent(window.location.href),
    fromUrl: encodeURIComponent(document.referrer),
  };
  sendMassage("unload", unLoad);
});

// 投放
var messageID = window.location.search.slice(5);
var addToCart = document.getElementById("add-to-cart");
window.mtgReady(function () {
  if (typeof mintegralTracking == "function") {
    mintegralTracking("MTG_pagelist_start_loading", {});
  }
});
window.onload = function () {
  if (typeof mintegralTracking == "function") {
    mintegralTracking("MTG_pagelist_finish_loading", {});
  }
};
if (window.locationUrl == "https://drinkgenki.com/collections/all") {
  if (typeof mintegralTracking == "function") {
    mintegralTracking("MTG_pagedetail_shopall_start_loading", {
      // shopall页面开始加载
    });
  }
  window.onload = function () {
    if (typeof mintegralTracking == "function") {
      mintegralTracking("MTG_pagedetail_shopall_finish_loading", {
        // shopadd页面加载完毕
      });
    }
  };
  addToCart.onclick = function () {
    mintegralTracking("MTG_pagedetail_shopall_finish_loading", {
      // shopall点击添加购物车
    });
  };
}
if (
  window.locationUrl == "https://drinkgenki.com/collections/sparkling-water"
) {
  if (typeof mintegralTracking == "function") {
    mintegralTracking("MTG_pagedetail_sparklingwater_start_loading", {
      // sparklingwater页面开始加载
    });
  }
  window.onload = function () {
    if (typeof mintegralTracking == "function") {
      mintegralTracking("MTG_pagedetail_sparklingwater_finish_loading", {
        // sparklingwater页面加载完毕
      });
    }
  };
  addToCart.onclick = function () {
    mintegralTracking("MTG_pagedetail_shopall_finish_loading", {
      // sparklingwater点击添加购物车
    });
  };
}
if (window.locationUrl == "https://drinkgenki.com/collections/oolong-tea") {
  if (typeof mintegralTracking == "function") {
    mintegralTracking("MTG_pagedetail_rtea_start_loading", {
      // rtea页面开始加载
    });
  }
  window.onload = function () {
    if (typeof mintegralTracking == "function") {
      mintegralTracking("MTG_pagedetail_rtea_finish_loading", {
        // rtea页面加载完毕
      });
    }
  };
  addToCart.onclick = function () {
    mintegralTracking("MTG_pagedetail_shopall_finish_loading", {
      // rtea点击添加购物车
    });
  };
}

function urlTimeRun() {}
